import Quiz from './Quiz';
import './App.scss';

function App() {
  return (
    <div className="flex justify-center items-center h-full">
      <Quiz />
    </div>
  );
}

export default App;
